import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-inner">
          <div>
            <p>©2024 7-ELEVEN, Inc. All rights reserved.</p>
            <p>
              7-ELEVEN, 7NOW, 7Rewards, Brainfreeze, Big Bite, Big Gulp, Slurpee
              and the Tri-Stripe Design are registered trademarks of 7-ELEVEN.
            </p>
          </div>
          <div className="margin-top-1">
            <p>
              <a href="tel:+18557115933">1 (855) 711-5933</a> (use service code 711)
            </p>
            <p>
              <a href="mailto:privacypolicy@7-11.com">privacypolicy@7-11.com</a>
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
